module.exports = {
  transclude: true,
  controller: class MainController {

    static $inject = [
      '$element',
      '$ngRedux',
      '$scope',
      '$state',
    ];

    modalStates = [
      'login',
      'activation',
      'register',
      'forgotten_password',
      'reset_password',
      'patients.id.appointments.id.cancel',
      'patients.id.requests.id.cancel',
      'kiosk.login',
    ];

    constructor($element, $ngRedux, $scope, $state) {
      this.$element = $element;
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$state = $state;
    }

    $onInit() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        group: state.group,
      }))(this));

      this.$scope.$on('$stateChangeSuccess', (event, toState) => {
        // Check if the current state is a modal layout
        angular.element('body').toggleClass('-modal-layout', _.includes(this.modalStates, toState.name));
      });

      if (this.group.mainContactNumber) {
        this.$element.addClass('big-footer');
      }

      if (application.env === 'test') {
        this.$element.addClass('test-env');
      }

      angular.element('body').on('click', ($event) => {
        this.$scope.$root.$broadcast('viewport:clicked', { jsEvent: $event });
      });

      if (this.isQueueAvailable(this.group)) {
        new Promise(() => {
          this.dynamicLoadQueueItScript();
        });
      }
    }

    isQueueAvailable(group) {
      return (group && group.products && group.products.includes('PATIENT_QUEUE_IT')) || (group && group.commonProducts && group.commonProducts.includes('PATIENT_QUEUE_IT'));
    }

    dynamicLoadQueueItScript() {
      const firstScript = document.createElement('script');
      firstScript.src = '//static.queue-it.net/script/queueclient.min.js';
      firstScript.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(firstScript);

      const secondScript = document.createElement('script');
      secondScript.src = '//static.queue-it.net/script/queueconfigloader.min.js';
      secondScript.type = 'text/javascript';
      secondScript.setAttribute('data-queueit-c', 'petalmd');
      document.getElementsByTagName('head')[0].appendChild(secondScript);
    }

    footerIsVisible() {
      return this.$state.current.name !== 'privacy_statement' && this.$state.current.name !== 'patient_agreement';
    }
  },
  template: `
    <patient-header></patient-header>
    <div id="mainView" class="main-view" ui-view="content" ng-class="{ '-no-footer': !$ctrl.footerIsVisible() }"></div>
    <app-footer ng-if="$ctrl.footerIsVisible()"></app-footer>
    <loading></loading>
  `,
};



// WEBPACK FOOTER //
// ./main/components/main.js